import {
  Gem, Shirt, Baby, Footprints, ShoppingBag, Heart, Waves, Sparkles,
  Smartphone, Home, ToyBrick, PartyPopper, Lamp, Dumbbell, PawPrint,
  UtensilsCrossed, Car, Package, Globe, Wrench, Gamepad2, SprayCan,
  Watch, Scissors, Shell, Store, Boxes, Brush, Ruler, Flower2,
  Building2, Truck, Tag, Gift, Palette, Crown, Glasses, Bike,
  Star, Zap, Cake,
  type LucideIcon
} from 'lucide-react';

export const ICONES: Record<string, LucideIcon> = {
  Gem, Shirt, Baby, Footprints, ShoppingBag, Heart, Waves, Sparkles,
  Smartphone, Home, ToyBrick, PartyPopper, Lamp, Dumbbell, PawPrint,
  UtensilsCrossed, Car, Package, Globe, Wrench, Gamepad2, SprayCan,
  Watch, Scissors, Shell, Store, Boxes, Brush, Ruler, Flower2,
  Building2, Truck, Tag, Gift, Palette, Crown, Glasses, Bike,
  Star, Zap, Cake,
};

export const ICONE_PADRAO = Store;

export function getIcone(nome?: string | null) {
  if (!nome) return ICONE_PADRAO;
  // Tenta encontrar o ícone pelo nome exato ou removendo o prefixo "Lucide" que alguns podem ter no banco
  const normalizedName = nome.startsWith('Lucide') ? nome.substring(6) : nome;
  return ICONES[normalizedName] ?? ICONES[nome] ?? ICONE_PADRAO;
}
